<div class="unauthorized-container">
    <h1>Unauthorized</h1>
    <p>{{ message }}</p>
</div>
